import React, { Component } from 'react';
import ReactTopProgressBar from "react-top-progress-bar"

import "./App.css"


class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: 50,
      withShadow: true,
      color: "#CC0000",
      backgroundColor: "transparent",
      striped: false
    }
  }

  render() {
    return (
      <div>
        <ReactTopProgressBar {...this.state} />
        <div className="container">
          <p>Customize your progress bar!!</p>
          <div className="buttons">
            <button onClick={() => this.setState({ color: "#00AAFF" })}>Set color azure!</button>
            <button onClick={() => this.setState({ color: "#CC0000" })}>Set color red!</button>
            <button onClick={() => this.setState({ withShadow: !this.state.withShadow })}>Toggle shadow!</button>
            <button onClick={() => this.setState({ backgroundColor: "#EEEEEE" })}>Set background gray!</button>
            <button onClick={() => this.setState({ backgroundColor: "transparent" })}>Set background transparent!</button>
            <button onClick={() => this.setState({ backgroundColor: "transparent" })}>Set background transparent!</button>
            <button onClick={() => this.setState({ striped: !this.state.striped })}>Set striped!</button>
          </div>
          <div className="buttons">
            <p>Set some values!!</p>
            <button onClick={() => this.setState({ value: 0 })}>Set 0%!</button>
            <button onClick={() => this.setState({ value: 30 })}>Set 30%!</button>
            <button onClick={() => this.setState({ value: 60 })}>Set 60%!</button>
            <button onClick={() => this.setState({ value: 100 })}>Set 100%!</button>
          </div>
        </div>
      </div>
    );
  }
}

export default App;